import React, { useState, useContext, useEffect, useRef } from "react";
import {
  ToastsContainer,
  ToastContainer,
  ToastMessage,
  ProgressBar,
  ProgressFill,
} from "./styles";
import { Context } from "../../Store";
import { deleteToast } from "../../Store/Toasts/actions";

function Toast() {
  const { state } = useContext(Context);
  let toasts = state.toast;

  return (
    <ToastsContainer>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </ToastsContainer>
  );
}

function ToastItem({ toast }) {
  const DURATION = 5000;
  const [percent, setPercent] = useState(100);

  const { dispatch } = useContext(Context);

  useEffect(() => {
    if (toast.expiry === Infinity) return;

    const interval = setInterval(() => {
      const remaining = toast.expiry - Date.now();
      const newPercent = Math.max((remaining / DURATION) * 100, 0);
      setPercent(newPercent);
    }, 100);

    return () => clearInterval(interval);
  }, [toast.expiry]);

  // Auto-dismiss when percent hits 0
  useEffect(() => {
    if (percent === 0) {
      dispatch(deleteToast(toast.id));
    }
  }, [percent, dispatch, toast.id]);

  return (
    <ToastContainer type={toast.type} escape={!percent}>
      <ToastMessage>{toast.message}</ToastMessage>
      <ProgressBar>
        <ProgressFill percent={percent} type={toast.type} />
      </ProgressBar>
    </ToastContainer>
  );
}

export default Toast;

// function Toast() {
//   const { state, dispatch } = useContext(Context);
//   let toasts = state.toast;

//   return (
//     <ToastsContainer>
//       {toasts.map((toast) => {
//         console.log("Toast Data:", toast);

//         let escape = toast.expiry - 5000 < Date.now();
//         const DURATION = 5000;
//         const total = DURATION;
//         const remaining =
//           toast.expiry === Infinity ? DURATION : toast.expiry - Date.now();
//         const percent = Math.max((remaining / total) * 100, 0);

//         console.log("Percentage:", percent);

//         return (
//           <ToastContainer key={toast.id} type={toast.type} escape={escape}>
//             <ToastMessage>{toast.message}</ToastMessage>
//             <ProgressBar>
//               <ProgressFill percent={100} type={toast.type} />
//             </ProgressBar>
//           </ToastContainer>
//         );
//       })}
//     </ToastsContainer>
//   );
// }
// export default Toast;

// const timersRef = useRef({});
// const [tick, setTick] = useState(Date.now());

// useEffect(() => {
//   const interval = setInterval(() => {
//     setTick(Date.now()); // this will force re-render
//   }, 100); // update every 100ms for smooth animation

//   return () => clearInterval(interval);
// }, []);
// useEffect(() => {
//   const now = Date.now();

//   toasts.forEach((toast) => {
//     if (toast.expiry !== Infinity && !timersRef.current[toast.id]) {
//       const delay = toast.expiry - now;

//       if (delay > 0) {
//         timersRef.current[toast.id] = setTimeout(() => {
//           dispatch(deleteToast(toast.id));
//           delete timersRef.current[toast.id];
//         }, delay);
//       } else {
//         dispatch(deleteToast(toast.id));
//       }
//     }
//   });

//   return () => {
//     Object.values(timersRef.current).forEach(clearTimeout);
//     timersRef.current = {};
//   };
// }, [toasts, dispatch]);

{
  /* <IconContainer>
              <Icon
                size="20px"
                type={
                  toast.type === "inProgress"
                    ? "loading"
                    : toast.type == "success"
                    ? "tick"
                    : "cross"
                }
                color={colors.background}
              />
            </IconContainer> */
}

{
  /* {toast.type !== "inProgress" && (
              <IconContainer
                iconLeft={true}
                onClick={() => dispatch(deleteToast(toast.id))}
              >
                <Icon size="10px" type={"cross"} color={colors.background} />
              </IconContainer>
            )} */
}
